"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEventFromReceipt = void 0;
var _ethers = require("ethers");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const ethers = _objectSpread({}, _ethers.ethers);
if (ethers.version.includes("/5")) {
  ethers.Interface = ethers.utils.Interface;
  ethers.TransactionReceipt = ethers.ContractReceipt;
}

/**
 * Ethers v6, Get event from receipt.logs.
 * Ethers v5, Get event from receipt.events.
 *
 * @example ethers v5
 * ```
 * getEventFromReceipt<any>(
 *     receipt,
 *     (deployerContract.interface as any).getEventTopic("Deployment"),
 *     deployerContract.interface
 * ).args.deployed;
 *
 * ```
 *
 * @example ethers v6
 * ```
 * getEventFromReceipt<any>(
 *     receipt,
 *     "Deployment",
 *     deployerContract.interface
 * ).args.deployed;
 * ```
 *
 * @param receipt {TransactionReceipt | ContractReceipt}
 * @param topic {string}
 * @param iface {ethers.Interface | ethers.utils.Interface}
 * @returns
 */
const getEventFromReceipt = (receipt, topic, iface) => {
  // Check for receipt.events as only ethers V5 tx.wait() returns events object
  // https://ethereum.stackexchange.com/questions/152626/ethers-6-transaction-receipt-events-information
  if (receipt.events) {
    const event = receipt.events.find(evt => evt.topics[0] === topic);
    if (!event) throw new Error(`Cannot find topic ${topic}`);
    if (iface) return iface.parseLog(event);
    return event;
  }

  // Ethers V6
  const resLog = receipt.logs.find(log => {
    var _iface$parseLog;
    return ((_iface$parseLog = iface.parseLog(log)) === null || _iface$parseLog === void 0 ? void 0 : _iface$parseLog.name) === topic;
  });
  return iface.parseLog(resLog);
};
exports.getEventFromReceipt = getEventFromReceipt;